import { useLazyQuery, useQuery } from "@apollo/client"
import moment from "moment"
import { useContext, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Heading, Text, Flex, Box, Card, Button } from "rebass/styled-components"
import styled from "styled-components"
import { Skeleton } from "../components/loadingSkeleton/Skeleton"
import { OpenedConversationsContext } from "../contexts/openConversationsCounts"
import { GET_DASHBOARD_CARDS_DATA, GET_TODAYS_UPCOMINGS, GET_UPCOMINGS } from "../graphql/queries"
import { IGetTodaysUpcomingInput, IGetTodaysUpcomingOutput, IGetUpcominsInput, IGetUpcominsOutput } from "../graphql/types/queries/appointment"
import { IGetDashboardCardsDataInput, IGetDashboardCardsDataOutput } from "../graphql/types/queries/dashboard"
import { IUser } from "../graphql/types/queries/user"
import withSession from "../lib/withSession"
import { Constants } from "../utils/Constants"
import { Upcomings } from "./dashboard/Upcomings"
import MinimalCalendarGrid from "./dashboard/MinimalCalendarGrid"
import { MessagesListNoSearch } from "./messages/MessagesList"

interface IDashboard {
  session: IUser
}
const TopCard: React.FC<{ count?: number, text: string, loading: boolean, mr?: string, onClick?: () => void }> = ({ count, mr, children, text, loading, onClick }) => {
  return (
    <Card paddingY={['8px', '30px', '30px']} paddingX={'26px'} marginBottom={mr || '16px'} marginRight={mr || '0px'} style={{ flex: 'initial', cursor: !!onClick ? 'pointer' : '' }} onClick={() => {
      if (!!onClick) {
        onClick()
      }
    }}>
      <Flex alignItems={'center'}>
        {loading ? (
          <Skeleton height={27} width={40} />
        ) : (
          <Flex alignItems={'baseline'}>
            <Heading mr={2}>{count}</Heading>
            {children}
          </Flex>
        )}
      </Flex>
      <Text mt={2} style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)', fontSize: '16px' }}>{text}</Text>
    </Card>
  )
}
const Wrapper = styled(Flex)`
  overflow: auto;
  padding-right: 20px;
  padding-left: 20px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;
const WrapperMainCol = styled(Flex)`
padding-right: 20px;
  overflow: auto;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: #C9C9C9;
  margin-top: 25px;
  margin-bottom: 25px;
`

const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 100px;
  @media screen and (min-width: 68.8125em) {
  padding-left: ${() => `${Constants.OUTLETS_PADDING}px`};
  /* padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`}; */
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  padding-bottom: 0px;
  /* padding-bottom: 0; */
  }
`

const MetricsMobile = styled(Flex)`
display: none;
  /* display: flex;
  @media screen and (min-width: 1600px) {
    display: none;
  } */
`

const MetricsWeb = styled(Flex)`
  display: flex;
  @media screen and (max-width: 1601px) {
    display: none;
  }
`
const CalendarMobile = styled(Flex)`
/* display: flex;
@media screen and (min-width: 68.8125em) {
  display: none !important;
} */
  
`
const CalendarDesktop = styled(Flex)`
flex:1;
/* display: flex;
@media screen and (max-width: 68.8125em) {
  display: none !important;
} */
  
`
const Dashboard = ({ session }: IDashboard) => {
  const [selectedDate, setSelectedDate] = useState<string | null>(moment().format('MM/DD/YYYY'))
  const [bypassScroll, setBypassScroll] = useState(true)
  const upcomingsRef = useRef<any>(null)
  const navigate = useNavigate()
  const openedConversationsCount = useContext(OpenedConversationsContext)
  const [loadUpcomings, { data: dataUpcoming, loading: loadingUpcoming, error: errorUpcoming, refetch: refetchUpcoming }] = useLazyQuery<IGetUpcominsOutput, IGetUpcominsInput>(GET_UPCOMINGS)
  const { data: dataTodayUpcoming, loading: loadingTodayUpcoming, error: errorTodayUpcoming, refetch: refetchTodayUpcoming } = useQuery<IGetTodaysUpcomingOutput, IGetTodaysUpcomingInput>(GET_TODAYS_UPCOMINGS)
  const { data: dataDashboardCards, loading: loadingDashboardCards, error: errorDashboardCards, refetch: refetchDashboardCards } = useQuery<IGetDashboardCardsDataOutput, IGetDashboardCardsDataInput>(GET_DASHBOARD_CARDS_DATA)

  useEffect(() => {
    loadUpcomings({
      variables: {
        day: selectedDate
      }
    })
  }, [])
  useEffect(() => {
    loadUpcomings({
      variables: {
        day: selectedDate
      }
    })
  }, [selectedDate])

  const onDateSelection = (date: string | null) => {
    if (date !== selectedDate && upcomingsRef && upcomingsRef.current) {
      upcomingsRef.current.scrollIntoView()
    } else {
      setBypassScroll(false)
    }
    setSelectedDate(date)
  }

  const refetchUpcomings = () => {
    refetchUpcoming()
  }

  return (
    <Container style={{ height: '100%', maxHeight: '100%' }} overflowY={['auto']} id='ctnr'>
      <Flex flexDirection={'column'} style={{ height: '100%', maxHeight: '100%' }} overflowY={['auto']} flex={1}>
        <Heading mb={3} marginTop={[0, '30px', '30px']}>{`Hi ${session.firstName}`}</Heading>
        <Flex flexDirection={['column', 'row', 'row']} display={['none !important', 'flex !important', 'flex !important']}>
          <Flex>
            <Text style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)' }}>{`You have `}&nbsp;</Text>

            <>
              {loadingTodayUpcoming ? (<Skeleton width={40} />) : (
                <Box style={{ background: '#C5DCFE', borderRadius: '10px', padding: '0 8px' }}>
                  <Flex>
                    {(dataTodayUpcoming?.providerGetTodaysUpcomings || []).length > 0 ?
                      <Text>{dataTodayUpcoming?.providerGetTodaysUpcomings.length}&nbsp;</Text> : ''}
                    <Text>{`${dataTodayUpcoming?.providerGetTodaysUpcomings.length === 0 ? 'no patient' : (dataTodayUpcoming?.providerGetTodaysUpcomings.length || 0) < 2 ? 'patient' : 'patients'}`}</Text>
                  </Flex>
                </Box>
              )}
            </>
          </Flex>
          <Text style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)' }}>&nbsp;{`scheduled today and`}&nbsp;</Text>
          <Box style={{ background: '#C5DCFE', borderRadius: '10px', padding: '0 8px', cursor: 'pointer', flex: 'initial' }} mt={[1, 0, 0]} onClick={() => navigate('/messages')}>
            <Flex>
              <Text>{openedConversationsCount}&nbsp;</Text>
              <Text>{` ${openedConversationsCount < 2 ? 'message' : 'messages'} `}</Text>
            </Flex>
          </Box>
        </Flex>
        <MetricsMobile flexDirection={['column', 'row', 'row']} mt={4} mb={[0, 2, 2]} justifyContent="flex-start">
          <TopCard mr='8px' loading={loadingDashboardCards} count={dataDashboardCards?.getProviderDashboardCardsData.thisMonth} text='Consultations this month'>
            {!loadingDashboardCards && (<Box style={{ background: '#BCFFEB', borderRadius: '10px', padding: '0 12px', height: '24px' }}>
              <Text color={'#4AA98C'}>{(dataDashboardCards?.getProviderDashboardCardsData.thisMonth || 0) - (dataDashboardCards?.getProviderDashboardCardsData.past || 0) > 0 ? `+${(dataDashboardCards?.getProviderDashboardCardsData.thisMonth || 0) - (dataDashboardCards?.getProviderDashboardCardsData.past || 0)}` : (dataDashboardCards?.getProviderDashboardCardsData.thisMonth || 0) - (dataDashboardCards?.getProviderDashboardCardsData.past || 0)} </Text>
            </Box>)}
          </TopCard>
          <TopCard mr='8px' loading={loadingDashboardCards} count={dataDashboardCards?.getProviderDashboardCardsData.future} text='Future Consultations scheduled'>
          </TopCard>
          <TopCard mr='8px' loading={false} count={openedConversationsCount} text='Open patient conversations' onClick={() => {
            navigate('/messages')
          }} >
          </TopCard>
        </MetricsMobile>
        <Divider />
        <Flex flex={1} overflow={'hidden'}>
          <WrapperMainCol flexDirection={['column']} flex={1}>

            <Flex maxWidth={'450px'} flex={1} flexDirection={['column']} mt={0} mb={4}>
              <Box ref={upcomingsRef} style={{ flex: 1 }} >
                <Upcomings data={dataUpcoming} loading={loadingUpcoming} error={errorUpcoming} refetch={refetchUpcomings} selectedDate={selectedDate} setSelectedDate={onDateSelection}/>
              </Box>
              {/* <CalendarDesktop display={['none !important', 'flex !important', 'flex !important']}>
            <CalendarGrid selectedDate={selectedDate} setSelectedDate={onDateSelection} />
          </CalendarDesktop>
          <CalendarMobile display={['flex  !important', 'none !important', 'none !important']}>
            <MobileCalendar selectedDate={selectedDate} setSelectedDate={onDateSelection} />
          </CalendarMobile> */}
            </Flex>
          </WrapperMainCol>
          <Flex flexDirection={['column']}>
            <Flex flexDirection={'column'} ml={3} maxWidth={'480px'} overflow={'hidden'}>
              <Flex mb={'20px'}>
                <Heading style={{ fontSize: '24px' }} flex={1}>Your open conversations</Heading>
                <Button onClick={() => navigate('/messages')} variant={'outline'} style={{ width: 'initial', fontSize: '14px' }}>Go to inbox</Button>
              </Flex>
              <WrapperMainCol>
                <MessagesListNoSearch onSelectConversation={() => { }} isEmbed />
              </WrapperMainCol>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <MetricsWeb width={'420px'} style={{ backgroundColor: 'white' }} height={'100%'} flexDirection={'column'} overflow={'hidden'} ml={4}>
        <Heading paddingLeft={'20px'} mb={3} marginTop={[0, '30px', '30px']}>Your Metrics</Heading>
        <Wrapper flexDirection={'column'} flex={1}>
          <TopCard loading={loadingDashboardCards} count={dataDashboardCards?.getProviderDashboardCardsData.thisMonth} text='Consultations this month'>
            {!loadingDashboardCards && (<Box style={{ background: '#BCFFEB', borderRadius: '10px', padding: '0 12px', height: '24px' }}>
              <Text color={'#4AA98C'}>{(dataDashboardCards?.getProviderDashboardCardsData.thisMonth || 0) - (dataDashboardCards?.getProviderDashboardCardsData.past || 0) > 0 ? `+${(dataDashboardCards?.getProviderDashboardCardsData.thisMonth || 0) - (dataDashboardCards?.getProviderDashboardCardsData.past || 0)}` : (dataDashboardCards?.getProviderDashboardCardsData.thisMonth || 0) - (dataDashboardCards?.getProviderDashboardCardsData.past || 0)} </Text>
            </Box>)}
          </TopCard>
          <TopCard loading={loadingDashboardCards} count={dataDashboardCards?.getProviderDashboardCardsData.future} text='Future Consultations scheduled'>
          </TopCard>
          <TopCard loading={false} count={openedConversationsCount} text='Open patient conversations' onClick={() => {
            navigate('/messages')
          }} >
          </TopCard>
        </Wrapper>
      </MetricsWeb>
    </Container >
  )
}

export default withSession(Dashboard)